module.exports = __webpack_public_path__ + "img/true.e9e161e9.svg";